import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 55 56"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m20.681 41.28 23.53-23.53q.833-.831 1.978-.832 1.145 0 1.978.833.833.832.833 1.978c0 1.146-.278 1.423-.833 1.978L22.625 47.25q-.832.834-1.944.833-1.11 0-1.943-.833L6.8 35.311q-.834-.832-.799-1.978.036-1.145.868-1.978.833-.833 1.978-.833t1.978.833z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }